import { styled } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';

export const StageStatusColumn = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'end',
  alignItems: 'flex-start',
}));

export const StageStatusText = styled(Typography)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
}));
